var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.selected ? 'chip chip-selected' : 'chip',domProps:{"textContent":_vm._s(_vm.text)},on:{"click":function($event){return _vm.$emit('click', _vm.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }